import React, { useContext, useEffect } from 'react'
import deleteIcon from '../../images/png/deleteIcon.png'
import editIcon from '../../images/png/editIcon.png'
import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { MercadoLivreContext } from '../../context/mercadoLivre'

const Image = styled.img`
    width: 28px;
    height:26px;
    object-fit: contain;

    @media screen and (max-width:720px){

        width: 21px;
        height: 21px;
        margin-left: 0.8rem;
        
    }

`
const ImageProduct = styled.img`
    width: 66px;
    height:66px;
    object-fit: contain;

    @media screen and (max-width:720px){

        width: 21px;
        height: 21px;
        margin-left: 0.8rem;
        
    }

`
const ButtonStatus = styled.button`
    font-family: "Poppins";
    font-weight: 600;
    width: 106px;
    height: 28px;
    border: none;
    font-size: 11px;
    border-radius: 60px;

    @media screen and (max-width:820px){
        width: 100%;
        font-size: 9px;
        border-radius:50px;
        
    }


`
const TableListMercadoLivre = ({ data, structure }) => {
    const {products,getProducts} = useContext(MercadoLivreContext)

    useEffect(() => {
        getProducts()
    },[])

    return (
        <div className='container_startpn_table_categorys'>
            <table>

                <thead className='container_startpn_table_categorys'>
                    <tr>
                        {structure?.map((item, index) => {
                            return (
                                <td key={index}>{item.name}</td>

                            )
                        })}
                    </tr>
                </thead>


                <tbody className=''>
                    {String(products).length == 0

                        ?
                        <tr>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>

                        </tr>
                        :

                        products?.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td ><ImageProduct src={item.picture} /></td>
                                    <td >{item.title}</td>
                                    <td data-toggle="modal" data-target="">R$ {Number(item.price).toLocaleString("pt-BR",{minimumFractionDigits:2})}</td>
                                    <td data-toggle="modal" data-target="" > 
                                    {item.available_quantity <= 10
                                    ?
                                    <ButtonStatus style={{ background: "#FFF7AA", color: "#C6B200" }}>{item.available_quantity}</ButtonStatus>

                                    :
                                    <ButtonStatus style={{ background: "#E0FFF0", color: "#00B386" }}>{item.available_quantity}</ButtonStatus>

                                    }

                                    </td>

                                </tr>
                            )
                        })}



                </tbody>
            </table>
            <div style={{height:"5rem"}}></div>
        </div>
    )
}

export default TableListMercadoLivre